import React, { useEffect, useState, useRef } from "react";
import { Auth, Hub } from "aws-amplify";

enum UserState {
  SIGNED_OUT = "signedOut",
  SIGNED_IN = "signedIn",
  LOADING = "loading",
}

const LoginButtons = ({ disabled = false }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isDisabled, setIsDisabled] = useState(disabled);

  return (
    <form
      className="form-bg form-short"
      onSubmit={(e) => {
        e.preventDefault();
        setIsDisabled(true);
        Auth.signIn(username, password).then((user) => {
          //console.log({ user, description: "Signed in." });
        }).catch((err) => {
          setError(err.message);
          console.log({ error: err, description: "Error during Auth.signIn." });
          setIsDisabled(false);
        });
      }}
    >
      {error && (
        <p className="alert alert-danger hide saturn-alert" id="errMsg" style={{ display: "block" }}>
          {error}
        </p>
      )}
      <div className="saturn-form-group">
        <label htmlFor="email">Email:</label>
        <input disabled={disabled} value={username} onChange={(event) => { setUsername(event.currentTarget.value); }} name="email" id="email" autoComplete="username" className="form-control" placeholder="Enter your email to get started" />
      </div>
      <div className="saturn-form-group">
        <label htmlFor="password">Password:</label>
        <input disabled={disabled} value={password} onChange={(event) => { setPassword(event.currentTarget.value); }} type="password" id="password" name="password" autoComplete="password" className="form-control" placeholder="Enter your password to get started" />
      </div>
      <div className="saturn-form-group flex-end-btn">
        <button
          type="submit"
          className="btn btn-primary"
          disabled={isDisabled}
        >
        Continue
        </button>
      </div>
    </form>
);
};

export const SignInDefault = ({ onSignedIn = () => {} }) => {
  const isActive = useRef(true);
  const [user, setUser] = useState(null);
  const [userState, setUserState] = useState(UserState.LOADING);

  async function checkUser() {
    if (UserState.SIGNED_IN === userState) {
      // console.log("Found user, not going to check again.");
      return;
    }

    if (UserState.SIGNED_OUT === userState) {
      // console.log("Signed out, not going to check user.");
      return;
    }

    await Auth.currentAuthenticatedUser()
      .then((currentUser) => {
        if (isActive.current) setUser(currentUser);
        if (isActive.current) setUserState(UserState.SIGNED_IN);
      })
      .catch((error: any) => {
        console.error({ description: "Error in Auth.currentAuthenticatedUser.", error });
      });
  }

  useEffect(() => {
    Hub.listen("auth", () => {
      if (isActive.current) setUserState(UserState.LOADING);
      checkUser();
    });
    checkUser();

    return () => {
      Hub.remove("auth", () => {});
      isActive.current = false;
    };
  });

  if (user) {
    onSignedIn();
    return <LoginButtons disabled />;
  }

  return <LoginButtons />;
};
